import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=52d6e708&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=52d6e708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6e708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d6e708')) {
      api.createRecord('52d6e708', component.options)
    } else {
      api.reload('52d6e708', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=52d6e708&scoped=true&", function () {
      api.rerender('52d6e708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8x8HNaOJ4XDDR/JS/comp/DocBox.vue"
export default component.exports